import { Icon, Tooltip, Button, Text } from '@nimbus-ds/components';
import { GenerativeStarsIcon } from '@nimbus-ds/icons';
import { useAgentChatPanelContext } from 'App/components/AgentChatPanelContext';
import { useTranslationCommon } from 'commons/hooks';

function AgentChatCTA() {
  const t = useTranslationCommon();
  const { openAgent } = useAgentChatPanelContext();

  return (
    <Tooltip content={t('topbar.agent.tooltip')} position="left">
      <Button appearance="ai-secondary" onClick={openAgent}>
        <Icon
          source={<GenerativeStarsIcon size="small" />}
          color="ai-generative"
        />
        <Text color="neutral-textHigh" fontWeight="medium">
          {t('topbar.agent.title')}
        </Text>
      </Button>
    </Tooltip>
  );
}

export default AgentChatCTA;
